<template>
  <div class="reg-detail-page">
    <div class="info-introduce">
      <!-- 个人信息 -->
      <div class="user-info" id="userInfo">
        <div class="info-title">
          <span>个人信息</span>
          <!-- <span class="print-card" @click="toPrintCard">打印准考证</span> -->
        </div>
        <el-form :model="allData" label-position="left" label-width="80px">
          <el-form-item label="考试科目">
            <span>{{ allData.subjectName }}</span>
          </el-form-item>
          <el-form-item label="报名期数">
            <span>{{ allData.subjectName }}第{{ allData.sequence }}期</span>
          </el-form-item>
          <el-form-item label="报名时间">
            <span>{{ allData.signBeginTime }} 至 {{ allData.signEndTime }}</span>
          </el-form-item>
          <el-form-item label="考试日期">
            <span>{{allData.examBeginTime? allData.examBeginTime.slice(0, 10):'' }}</span>
            <span style="color: #a2aabb">&nbsp;(考试前7日可以打印准考证)</span>
          </el-form-item>
          <el-form-item label="考生姓名">
            <span>{{ allData.name }}</span>
          </el-form-item>
          <el-form-item label="手机号">
            <span>{{ allData.mobile }}</span>
          </el-form-item>
          <el-form-item label="性别">
            <span v-if="allData.sex == 1">男</span>
            <span v-else-if="allData.sex == 2">女</span>
            <span v-else-if="allData.sex == 3">保密</span>
          </el-form-item>
          <el-form-item label="证件类型">
            <span v-if="allData.cardType == 1">身份证</span>
            <span v-else-if="allData.cardType == 2">护照</span>
            <span v-else-if="allData.cardType == 3">港澳台通行证</span>
          </el-form-item>
          <el-form-item label="身份证号">
            <span>{{ allData.card }}</span>
          </el-form-item>
          <el-form-item label="身份证照片">
            <img class="user-card" :src="allData.cardFrontPicUrl" />
            <img class="user-card" style="margin-left: 8px" :src="allData.cardBackPicUrl" />
          </el-form-item>
          <el-form-item label="证件照">
            <img class="user-avatar" :src="allData.threeMonthPicUrl" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="reg-info-box">
      <span class="reg-info-title">考试报名信息</span>
      <el-table :data="allData.examResultForStudentList" :header-cell-style="{
          'background-color': '#FAFAFA',
          'font-family': '微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑',
          'font-weight': '700',
          color: '#455A64',
        }">
        <el-table-column label="姓名" align="left">
          <template>
            <span>{{ allData.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试课程" prop="courseName" align="center" />
        <el-table-column label="考试日期" prop="examBeginTime" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.examBeginTime.slice(0, 10) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试时间" prop="examBeginTime" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.examBeginTime.slice(11, 19) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试类型" prop="type" align="center">
          <template>
            <span> 线上 </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.studentState==1" style="color:#FFC349;">未交费</span>
            <span v-if="scope.row.studentState==2" style="color:#455A64;">已缴费</span>
            <span v-if="scope.row.studentState==3" style="color:#24D2B5;">考试中</span>
            <span v-if="scope.row.studentState==4" style="color:#C1B1C2;">考试结束</span>
            <span v-if="scope.row.studentState==5" style="color:#FFC349;">缺考</span>
          </template>
        </el-table-column>
        <el-table-column label="考试费用" prop="examinationFee" align="right">
          <template slot-scope="scope">
            <span class="examination-fee">{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        >
      </el-table>
      <div class="all-price">
        共计： <span class="examination-fee">￥{{ total }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // beforeRouteLeave(to, from, next) {
  //   if (to.path != "/printCard") {
  //     from.meta.keepAlive = false;
  //   }
  //   next();
  // },
  // beforeRouteEnter(to, from, next) {
  //   if (to.params.id || from.path == "/printCard") {
  //     next();
  //   }
  // },
  data () {
    return {
      labelPosition: "right",
      courseList: [
        {
          topText: "套餐",
          className: "2020初级会计职称",
          classText: "60分签约冲刺班",
          remark: "（不过退费）",
          num: "20000",
          price: "350",
        },
        {
          topText: "套餐",
          className: "2020初级会计职称",
          classText: "60分签约冲刺班",
          remark: "（不过退费）",
          num: "20000",
          price: "350",
        },
        {
          topText: "套餐",
          className: "2020初级会计职称",
          classText: "60分签约冲刺班",
          remark: "（不过退费）",
          num: "20000",
          price: "350",
        },
        {
          topText: "套餐",
          className: "2020初级会计职称",
          classText: "60分签约冲刺班",
          remark: "（不过退费）",
          num: "20000",
          price: "350",
        },
        {
          topText: "套餐",
          className: "2020初级会计职称",
          classText: "60分签约冲刺班",
          remark: "（不过退费）",
          num: "20000",
          price: "350",
        },
        {
          topText: "套餐",
          className: "2020初级会计职称",
          classText: "60分签约冲刺班",
          remark: "（不过退费）",
          num: "20000",
          price: "350",
        },
        {
          topText: "套餐",
          className: "2020初级会计职称",
          classText: "60分签约冲刺班",
          remark: "（不过退费）",
          num: "20000",
          price: "350",
        },
      ],
      allData: {},
      isPrint: false,
    };
  },
  computed: {
    total () {
      let price = 0;
      this.allData.examResultForStudentList.forEach((item) => {
        price += item.amount;
      });
      return price;
    },
  },
  created () {
    // console.log(this.$route.params);
    this.getUserInfo();
  },
  methods: {
    //获取考生信息
    getUserInfo () {
      this.api.examStudent.getSystemStuDetailInfo({
        "studentId": this.$route.query.studentId,
        "examinationSettingId": this.$route.query.examinationSettingId
      }).then((res) => {
        if (res.code == 200) {
          this.allData = res.data;
          console.log(this.allData, '9999', new Date(), new Date().valueOf())
          let time = new Date(
            this.allData.examBeginTime ? this.allData.examBeginTime.slice(0, 10) + " 00:00:00" : ''
          ).valueOf();
          let timeNow = new Date().valueOf();
        }
      });
    },
  },
};
</script>

<style scoped>
.course-recommend {
  position: relative;
  width: 100%;
  margin-bottom: 30px;
}
.course-recommend > p {
  margin-top: 40px;
  /* margin-bottom: 30px; */
  font-family: "微软雅黑";
  font-size: 24px;
  color: #455a64;
}
.all-course-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.all-course-box :nth-child(4n + 4) {
  margin-right: 0;
}
.item-course-box {
  width: 285px;
  height: 300px;
  border-radius: 4px;
  margin-top: 20px;
  margin-right: 20px;
  background-color: #fff;
}
.item-course-box:hover {
  transform: translateY(-10px);
}
.course-top {
  position: relative;
}
.img-top-text {
  position: absolute;
  display: inline-block;
  right: 10px;
  top: 0;
  background-color: #eab978;
  color: #fff;
  width: 35px;
  height: 18px;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
}
.course-img {
  width: 285px;
  height: 190px;
}
.course-center-text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.course-center-text > span {
  font-family: "微软雅黑";
  font-size: 24px;
  color: #fff;
  text-align: center;
}
.course-bottom {
  position: relative;
  box-sizing: border-box;
  height: calc(100% - 190px);
  padding: 10px 25px 10px 20px;
}
.course-name {
  font-family: "微软雅黑";
  font-size: 16px;
  color: #455a64;
}
.course-detial {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.num {
  margin-top: 20px;
  font-weight: 400;
  font-size: 12px;
  color: #a2aabc;
}
.price {
  position: absolute;
  bottom: 20px;
  right: 24px;
  font-size: 14px;
  color: #fc5e5e;
}
.price > span {
  font-size: 24px;
}

.reg-info-box {
  position: relative;
  box-sizing: border-box;
  margin-top: 20px;
  padding: 30px;
  height: 270px;
  background-color: #fff;
  border-radius: 4px;
}
.examination-fee {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
  font-weight: 700;
  font-size: 14px;
  color: #fc5e5e;
}
.reg-info-title {
  display: inline-block;
  margin-bottom: 10px;
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
  font-weight: 700;
  font-size: 16px;
  color: #455a64;
}
.all-price {
  float: right;
  margin-right: 10px;
  margin-top: 20px;
  font-size: 14px;
}

.studentInformation_breadcrumb {
  margin-bottom: 10px;
}
.studentInformation_breadcrumb_index {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
  font-weight: 700;
  font-size: 14px;
  color: #455a64;
}
.studentInformation_breadcrumb_index:hover {
  cursor: pointer;
  color: #006aff;
}
.breadcrumb-last {
  font-family: "微软雅黑";
  font-weight: 400;
  color: #a2aabc;
  font-size: 14px;
}
.exm-info :first-child {
  margin-top: 0;
}
.item-box {
  position: relative;
  width: 100%;
  margin-top: 20px;
}
.item-head {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
}
.line {
  height: 21px;
  border-left: 2.5px solid #466bfb;
  margin-right: 7px;
}
.item-text {
  position: relative;
  width: calc(100% - 10px);
  margin-left: 10px;
  color: #abaaca;
  line-height: 22px;
  font-size: 14px;
}
.reg-detail-page {
  position: relative;
}
.info-introduce {
  position: relative;
  background-color: #fff;
  height: 750px;
  display: flex;
}
.info-introduce > div {
  padding: 30px;
}
.user-info {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* flex: 1; */
}
.el-form-item {
  margin-bottom: 0;
}
.info-title {
  position: relative;
  margin-top: -10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-title :first-child {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑;
  font-weight: 700;
  font-size: 16px;
  color: rgb(69, 90, 100);
}
.print-card {
  width: 120px;
  height: 40px;
  background-color: rgb(0, 106, 255);
  color: rgb(255, 255, 255);
  border-radius: 80px;
  line-height: 40px;
  text-align: center;
}
.print-card:hover {
  background-color: #4189fc;
}
.user-card {
  margin-top: 10px;
  width: 190px;
  height: 122px;
}
.user-avatar {
  margin-top: 10px;
  width: 87px;
  height: 123px;
}
.exm-info {
  height: calc(100% - 65px);
  width: calc(1200px - 725px);
  overflow: scroll;
}
::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}
</style>
<style>
#userInfo > .el-form > .el-form-item > .el-form-item__label {
  color: #a2aabb;
  padding: 0;
}
p {
  margin: 0;
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/testSystem/systemStudentDetail.vue